import { useValidateIsAlwaysValid, useValidateIsNotEmptyArray } from "formvalidation/hooks";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import React from "react";

interface Props<T> {
  readonly?: boolean
  options: T[]
  getId: (item: T) => number
  getTitle: (item: T) => string
  selectedIds: number[]
  onChange: (ids: number[]) => void
  header: JSX.Element
  checkboxLabel: string
  validatorKey?: string
  canBeEmpty?: boolean
}

const CheckboxList = <T extends unknown>(props: Props<T>) => {
  const checkedItems: Set<number> = new Set<number>(props.selectedIds);

  const onChange = (id: number) => {
    const checkedItemsCopy = new Set(checkedItems);
    if (checkedItemsCopy.has(id)) {
      checkedItemsCopy.delete(id);
    } else {
      checkedItemsCopy.add(id);
    }
    props.onChange(Array.from(checkedItemsCopy));
  };

  const allChecked = props.options.length === checkedItems.size;

  const toggleAll = () => {
    if (allChecked) {
      props.onChange([]);
    } else {
      props.onChange(props.options.map(props.getId));
    }
  };

  const validation = props.canBeEmpty
    ? useValidateIsAlwaysValid(props.validatorKey, props.validatorKey)
    : useValidateIsNotEmptyArray({
      key: props.validatorKey,
      title: props.validatorKey,
      value: props.selectedIds,
    });


  const renderReadonly = (checked: boolean) => {
    if (checked) {
      return <i className="icon-check green" />
    }

    return <i className="icon-x red" />
  }


  return <div className="checkbox-list-grid">
    <div className="checkbox-list-grid-header">{props.header}</div>
    <div className="checkbox-list-grid-header">
      {!props.readonly && <Checkbox
        checked={allChecked}
        onChange={toggleAll}
        label={props.checkboxLabel}
        error={validation.error.hasError}
      />}
    </div>
    {props.options.map(o => <React.Fragment key={props.getId(o)}>
      <div>{props.getTitle(o)}</div>
      {props.readonly ? renderReadonly(checkedItems.has(props.getId(o))) : <Checkbox
        checked={checkedItems.has(props.getId(o))}
        onChange={() => { onChange(props.getId(o)); }}
        error={validation.error.hasError}
      />}
      <div className="checkbox-list-grid-border" />
    </React.Fragment>
    )}
  </div>;
};

export default CheckboxList;